import { useQuery } from '@tanstack/react-query';
import { expertTipApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

export function useExpertTip(id: string) {
  return useQuery({
    queryKey: queryKeys.expertTips.detail(id),
    queryFn: () => expertTipApi.getExpertTip(id),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 1,
  });
}
